// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash/fp';
import classNames from 'classnames';

// Utils
import { getUserId } from '../../../../../common/users/utils/userPropertyUtils';
import { stopDefaultAndPropagation } from '../../../../utils/domUtil';

// Components
import FloatingPanel from '../../../tooltips/FloatingPanel';
import UserDetailsListEntry from '../../../userAvatar/UserDetailsListEntry';

// Constants
import { TooltipPositions } from '../../../tooltips/tooltipConstants';

// Styles
import './UserSelectionInputSuggestions.scss';

// TODO Disable, show spinner, etc, when submitting
const UserSelectionInputSuggestion = ({ user, active, handleAddUserFromSuggestion }) => {
    const onClick = () => handleAddUserFromSuggestion({ user });

    return (
        <div
            className={classNames('UserSelectionInputSuggestion', { active })}
            onMouseDown={stopDefaultAndPropagation}
            onClick={onClick}
        >
            <UserDetailsListEntry user={user} />
        </div>
    );
};

UserSelectionInputSuggestion.propTypes = {
    user: PropTypes.object,
    active: PropTypes.bool,
    handleAddUserFromSuggestion: PropTypes.func,
};

const UserSelectionInputSuggestions = (props) => {
    const {
        forceClose,
        hovered,
        setHovered,
        focused,
        focusedIndex,
        suggestedUsers,
        handleAddUserFromSuggestion,
        isPhoneOrMobileAppMode,
    } = props;

    if ((!focused && !hovered) || forceClose || isEmpty(suggestedUsers)) return null;

    return (
        <FloatingPanel
            pollPosition
            className="UserSelectionInputSuggestions light"
            selector="#email-input-suggestions-target"
            arrowHeight={0}
            arrowWidth={0}
            distance={0}
            offset={0}
            delay={0}
            onMouseDown={stopDefaultAndPropagation}
            position={TooltipPositions.BOTTOM}
            relativeParentSelector={isPhoneOrMobileAppMode ? '#app .Sheet' : null}
        >
            <div
                className="suggestions-container"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                {suggestedUsers.map((user, index) => (
                    <UserSelectionInputSuggestion
                        key={getUserId(user)}
                        handleAddUserFromSuggestion={handleAddUserFromSuggestion}
                        active={index === focusedIndex}
                        user={user}
                    />
                ))}
            </div>
        </FloatingPanel>
    );
};

UserSelectionInputSuggestions.propTypes = {
    suggestedUsers: PropTypes.array,
    forceClose: PropTypes.bool,
    hovered: PropTypes.bool,
    isPhoneOrMobileAppMode: PropTypes.bool,
    setHovered: PropTypes.func,
    focused: PropTypes.bool,
    focusedIndex: PropTypes.number,
    handleAddUserFromSuggestion: PropTypes.func,
};

export default UserSelectionInputSuggestions;
